import type { ScoreEntry } from './types'

export function historyDate(h: ScoreEntry): string {
  return h.recordedDate || h.date || ''
}

export function historyTestDate(h: ScoreEntry): string {
  return h.officialTestDate || h.testDate || ''
}

export function formatHistoryScore(value: string | number | undefined | null): string {
  if (value === null || value === undefined || value === '') return ''
  const num = Number(value)
  return Number.isFinite(num) ? num.toFixed(1) : String(value)
}

export function shortHistoryDate(h: ScoreEntry): string {
  const date = String(historyDate(h) || '')
  return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(5, 10) : date.slice(0, 5)
}
